<template>
  <div v-if="show" class="loading-wrapper">
    <img src="/images/osmanlicalogo.svg" class="rotating-logo" alt="Logo" />
    <p class="loading-message">Lütfen bekleyin, yönlendiriliyorsunuz...</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    // 2 saniye sonra yükleme ekranını kapat
    setTimeout(() => {
      this.show = false;
    }, 2000);
  },
};
</script>

<style scoped>
.loading-wrapper {
  position: fixed;
  inset: 0;
  background: #1e1e1e;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.rotating-logo {
  width: min(250px, 80vw);
  height: min(250px, 80vw);
  animation: scaleUp 1.5s ease-out forwards;
  transform: scale(0);
}

.loading-message {
  color: #ffffff;
  font-size: 1rem;
  text-align: center;
}

@keyframes scaleUp {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  60% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 480px) {
  .loading-message {
    font-size: 0.9rem;
    line-height: 1.4;
    padding: 0 10px;
  }

  .rotating-logo {
    width: 60vw;
    height: 60vw;
  }
}

</style>
